<template>
  <el-config-provider :locale="locale">
    <div id="app">
      <router-view></router-view>
    </div>
  </el-config-provider>
</template>

<script>
import elenLocale from 'element-plus/dist/locale/en.mjs';
import elzhLocale from 'element-plus/dist/locale/zh-cn.mjs';
export default {
  name: "app",
  computed: {
    locale() {
      return this.$store.getters.lang.type === 'zh-CN' ? elzhLocale : elenLocale
    }
  },
  watch: {
    locale: {
      handler(newVal) {
        if (this.$store.getters.lang.type === 'zh-CN') {
          document.title = "商户终端管理平台";
        } else {
          document.title = "Terminal Management System";
        }
      },
      // 强制立即执行回调
      immediate: true
    }
  },
};

// 解决ERROR ResizeObserver loop completed with undelivered notifications.问题的
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}
// 解决ERROR ResizeObserver loop completed with undelivered notifications.问题的
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
</script>

<style>
html,body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 556px;
}
#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
  background: #4a5967;
}

#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
  background: #303f4e !important;
  color:#fff !important;
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  background: #3d5063 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover{
    background: #668098 !important;
}

#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, #app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    color: #fff;
    background: #5d748a !important;
}

#app .ivu-menu-vertical .ivu-menu-item, #app .ivu-menu-vertical .ivu-menu-submenu-title{
    color:#fff;
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
    background: #4a5967 !important;
}

.ivu-menu{
    background-color: #4a5967;
}
.ivu-modal-header p, .ivu-modal-header-inner{
    color: #5C5C5C;
    font-size: 12px;
}
.u-container {
  background-color: #fff;
  padding: 16px;
}
  .ivu-table-body{
    /*overflow: hidden !important;*/
  }
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
